export const thongTinVatHangHoa = {
  sections: {
    list: { title: '商品增值税信息' },
  },
  titles: {
    add: '新增增值税信息',
    edit: '编辑增值税信息',
  },
  fields: {
    maSanPham: '商品编码',
    ghiChu: '备注',
    ngayHachToan: '记账日期',
    dienGiai: '摘要',
    loaiTien: '币种',
    tyGia: '汇率',
    maHangKeToan: '会计商品编码',
    congTy: '公司',
    tenHangKhaiVat: '增值税申报品名',
    ghiChuMang: '板块备注',
    tkKho: '库存科目',
    tkCongNo: '应付/资金科目',
    donViTinh: '单位',
    soLuong: '数量',
    donGia: '单价',
    thanhTien: '金额',
    donGiaVnd: '单价(越南盾)',
    phanTramThueGtgt: '增值税率 %',
    tienThueGtgt: '增值税额',
    tienThueGtgtQuyDoi: '增值税额(折算)',
    tkDoiUngThueGtgt: '增值税对方科目',
    tkThueGtgt: '增值税科目',
    nhomHhdvMuaVao: '进项货物/服务组',
    phiTruocHaiQuan: '报关前费用',
    giaTinhThueNk: '进口税计税价',
    phanTramThueNk: '进口税率 %',
    hangHoa: '系统商品',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
  },
  filter: {
    searchPlaceholder: '搜索',
    textDetailTitle: '详细筛选',
    dateRangePlaceholder: '选择日期范围',
    fromDate: '开始日期',
    toDate: '结束日期',
    noOptions: '暂无数据',
    lienKetAll: '全部',
    lienKetCo: '系统中已有',
    lienKetKhong: '系统中没有',
  },
  filters: {
    hintSection: '搜索',
    hintBody: '在上方搜索框输入商品编码、会计商品编码、增值税申报品名、摘要或公司。',
  },
  placeholders: {
    maSanPham: '按商品编码或名称搜索',
    noProduct: '未找到商品',
  },
  hints: {
    chuaLienKet: '系统中不存在',
  },
  messages: {
    productTabEmpty: '该商品暂无增值税信息。',
    loadError: '无法加载增值税信息列表。',
    noData: '暂无商品增值税信息。',
    listSummary: '共 {count} 行',
    saveSuccess: '增值税信息已保存。',
    deleteSuccess: '已删除增值税信息行。',
    confirmDelete: '删除编码 "{name}" 的增值税信息行？',
    selectedCount: '已选 {count}',
    deleteSelected: '删除所选 ({count})',
    bulkDeleteConfirm: '删除所选 {count} 行增值税信息？',
    bulkDeleteSuccess: '已删除 {count} 行',
    bulkDeleteError: '批量删除失败',
  },
  validation: {
    maSanPhamRequired: '请输入商品编码。',
  },
  import: {
    description:
      '下载模板并按列标题(第1行)填写。数字支持 4.216 / 0,16 格式。记账日期格式 dd/mm/yyyy，无日期可留空或填 00/01/1900。若有错误行，将不导入任何数据。',
    cheDoNhap: '导入方式',
    cheDoThemMoi: '追加 — 保留已有行',
    cheDoThayThe: '替换 — 删除文件中商品编码的旧行后重新导入',
    success: '增值税信息导入成功。',
    failed: '增值税信息导入失败。',
  },
}
